var Backbone, EmailFormIntlPhoneChannelView, SupportFlexPhoneChannelTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlexPhoneChannelTemplate = require('../../../../flex_phone_channel.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlPhoneChannelView = (function(superClass) {
  extend(EmailFormIntlPhoneChannelView, superClass);

  function EmailFormIntlPhoneChannelView() {
    return EmailFormIntlPhoneChannelView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlPhoneChannelView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportFlexPhoneChannelTemplate;
  };

  EmailFormIntlPhoneChannelView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormIntlPhoneChannelView.prototype.toHash = function() {
    var hash, mode, ref, ref1;
    if (((ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_three : void 0 : void 0) != null) {
      mode = window.liveChatInfo.mode.step_three;
    }
    return hash = {
      call_us_message: getCallUsMsg(),
      showStaticLiveChat: isStaticLiveChat(mode) || isBothLiveChats(mode)
    };
  };

  return EmailFormIntlPhoneChannelView;

})(Backbone.View);

module.exports = EmailFormIntlPhoneChannelView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9JTlRML3Bob25lX2NoYW5uZWxfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL0lOVEwvcGhvbmVfY2hhbm5lbF92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHdFQUFBO0VBQUE7OztBQUFBLCtCQUFBLEdBQWtDLE9BQUEsQ0FBUSw4Q0FBUjs7QUFDbEMsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7MENBRUosVUFBQSxHQUFZLFNBQUE7SUFDVixJQUFDLENBQUEsU0FBRCxHQUFhO1dBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtFQUZGOzswQ0FJWixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsTUFBRCxDQUFBLENBQWxCLEVBQTZCLElBQUMsQ0FBQSxTQUE5QixDQUFWO0VBRE07OzBDQUdSLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUcsNkdBQUg7TUFBK0MsSUFBQSxHQUFPLE1BQU0sQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLFdBQS9FOztXQUNBLElBQUEsR0FDRTtNQUFBLGVBQUEsRUFBa0IsWUFBQSxDQUFBLENBQWxCO01BQ0Esa0JBQUEsRUFBb0IsZ0JBQUEsQ0FBaUIsSUFBakIsQ0FBQSxJQUEwQixlQUFBLENBQWdCLElBQWhCLENBRDlDOztFQUhJOzs7O0dBVGtDLFFBQVEsQ0FBQzs7QUFlckQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
